import { render, staticRenderFns } from "./AudienceTextInput.vue?vue&type=template&id=a5ff5d30"
import script from "./AudienceTextInput.vue?vue&type=script&lang=ts"
export * from "./AudienceTextInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports